import {json, JsonMappers} from '../../../core/data-source/json.mapper';
import {DictionaryRecord} from '../../../records/dictionary.record';
import {TerritoryRecord} from '../../../records/territory.record';

export class PTVehicleFilterRecord {
    @json()
    vehicleName: string;
    @json()
    performerName: string;

    @json({
        value: false
    })
    active: boolean;

    @json()
    corrected: boolean;

    @json({
        value: false
    })
    haveAvailability: boolean;

    @json({
        value: false
    })
    haveSchedule: boolean;

    @json()
    performerNameNotEmpty: boolean;

    @json()
    performerScheduleZonesNotEmpty: boolean;

    @json()
    vehicleNameNotEmpty: boolean;
    @json()
    vehicleRequirementsNotEmpty: boolean;

    @json()
    vehicleScheduleZonesNotEmpty: boolean;

    @json({
        mapper: JsonMappers.ArrayOf(() => DictionaryRecord)
    })
    vehicleRequirements: DictionaryRecord[];

    @json({
        mapper: JsonMappers.ArrayOf(() => TerritoryRecord)
    })
    performerScheduleZones: TerritoryRecord[];

    @json({
        mapper: JsonMappers.ArrayOf(() => TerritoryRecord)
    })
    vehicleScheduleZones: TerritoryRecord[];

    isActive(): boolean {
        for (let [key, value] of Object.entries(this)) {
            if (Array.isArray(value) && value.length) {
                return true;
            }
            if (!Array.isArray(value) && Boolean(value) == true) {
                return true;
            }
        }
        return false;
    }
}
